export default "/_next/static/chunks/fonts/Ubuntu-Bold-latin-971823a78fcea744511028f62e62c80c.woff2";